var _mask, _g, _g2, _g3, _g4, _g5, _path, _path2, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacbook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 620 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 620,
    height: 390
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620 0H0v390h620V0zm-81 45H83v285.003h456V44.999z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1 73 360)",
    fill: "url(#paint0_linear)",
    d: "M0 0h475v3H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M28 360.907h475.2v1.2H28z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 587.2 360.907)",
    fill: "url(#paint2_linear)",
    d: "M0 0h475.2v1.2H0z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.8,
    y: 342.701,
    width: 500.4,
    height: 35.411,
    rx: 17.706,
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 22,
    width: 505,
    height: 330,
    rx: 15.6,
    fill: "url(#paint3_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M10 349h600v4H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257 349h107a3 3 0 01-3 3H260a3 3 0 01-3-3z",
    fill: "url(#paint5_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257 349h107a3 3 0 01-3 3H260a3 3 0 01-3-3z",
    fill: "#fff",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 360c-81.576 0-95-7-95-7l300-1 298 1s-13.386 7-95 7H106z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 353l-.001-.3-.138.566L11 353zm300-1l.001-.3h-.002l.001.3zm298 1l.139.266-.138-.566-.001.3zm-598 0l-.138.266.001.001.003.002.01.005.036.017a10.712 10.712 0 00.721.292c.537.195 1.39.471 2.664.801 2.548.66 6.788 1.537 13.574 2.414C41.44 358.55 65.205 360.3 106 360.3v-.6c-40.78 0-64.517-1.75-78.052-3.498-6.768-.873-10.983-1.746-13.5-2.399-1.26-.326-2.093-.596-2.61-.784a9.707 9.707 0 01-.668-.27l-.026-.013-.005-.002h-.001L11 353zm299.999-1.3l-300 1 .002.6 300-1-.002-.6zm0 .6l298 1 .002-.6-298-1-.002.6zM609 353l-.139-.266h0l-.005.003a9.737 9.737 0 01-.693.282c-.515.188-1.348.458-2.605.784-2.515.653-6.726 1.526-13.491 2.399C578.536 357.95 554.8 359.7 514 359.7v.6c40.814 0 64.578-1.75 78.144-3.502 6.783-.877 11.019-1.754 13.565-2.414 1.272-.33 2.123-.606 2.659-.801a10.6 10.6 0 00.72-.292l.036-.017.01-.006.003-.001.001-.001L609 353zm-95 6.7H311v.6h203v-.6zm-408 .6h205v-.6H106v.6z",
    fill: "url(#paint7_linear)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 492.4,
    y1: 360.921,
    x2: 28,
    y2: 360.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 11,
    y1: 352,
    x2: 11,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B4B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 11,
    y1: 352,
    x2: 11,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9ADB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 257,
    y1: 352,
    x2: 364,
    y2: 352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB2B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#C9CBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#D8DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#EEEFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EEEFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D8DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#C9CBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB2B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 10,
    y1: 351,
    x2: 610,
    y2: 351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.029,
    stopColor: "#D9DEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.091,
    stopColor: "#F1F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#E1E5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#D9DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#D6D8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D6D8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#D9DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#E1E5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F1F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#D9DEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 464.205,
    y1: 0.034,
    x2: 0,
    y2: 0.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -27.239,
    y1: 51.135,
    x2: 11.531,
    y2: 381.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 464.4,
    y1: 0.014,
    x2: 0,
    y2: 0.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 21.205,
    y: 354.112,
    width: 488.791,
    height: 14.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.398,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd",
    x: 41,
    y: 1,
    width: 539,
    height: 364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.130051 0 0 0 0 0.186328 0 0 0 0 0.270742 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 43.49,
    y: 326.391,
    width: 533.019,
    height: 68.031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.155,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 105.205,
    y: 354.112,
    width: 488.791,
    height: 14.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.398,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 66.205,
    y: 350.205,
    width: 488.591,
    height: 16.591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.398,
    result: "effect1_foregroundBlur"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacbook);
export default __webpack_public_path__ + "static/media/macbook.ae61a0eafb1061bf55966f40ac14cc02.svg";
export { ForwardRef as ReactComponent };